module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "line1"
  }, [_c('div', {
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_vm._v("小明")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-right": "10px"
    }
  }, [_vm._v("101-3")])]), _vm._v(" "), _c('div', {
    staticClass: "line2"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('img', {
    staticStyle: {
      "margin": "0 auto"
    },
    attrs: {
      "src": "http://org.yymedic.com/images/cardBreath.svg?4d21686641eae8e4dc81f52f09c226c8"
    }
  })])]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('div', {
    staticClass: "line3"
  }, [_c('span', [_vm._v("1")]), _vm._v(" "), _c('span', [_vm._v("2")]), _vm._v(" "), _c('span', [_vm._v("3")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6246543a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SmartCare.vue
// module id = 1278
// module chunks = 1